import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Stack } from 'react-bootstrap';
import PaginationBox from 'components/PaginationBox';
import { usePostedJobQuery } from 'services';
import { dataLimits, USER_TYPES } from 'constants';
import JobListingBox from 'components/Common/Jobs/JobListingBox';
import PostedJobSkeleton from 'components/Common/Skeleton/PostedJobSkeleton';
import { useParams } from 'react-router-dom';
import useAuthStore from 'store/auth';
import useSkeleton from 'hooks/useSkeleton';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';
import useLocalizationStore from 'store/localization';

const MyPostedJobs: React.FC = () => {
	const { translate } = useTranslate();
	const [currentPage, setCurrentPage] = useState(1);
	const { id: companyId = '' } = useParams<any>();
	const { user: authUser }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const { activeLanguage }: any = useLocalizationStore((state) => state);

	const queryOptions = `limit=${dataLimits?.postedJobsListing}&page=${currentPage}&userId=${companyId}`;
	const { data: { docs: jobs = [], meta = {} } = [], refetch } = usePostedJobQuery(queryOptions);
	const { limit = 10, totalDocs } = meta;

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const delayedLoading = useSkeleton(isLoading);

	useEffect(() => {
		setIsLoading(true);
		refetch().finally(() => {
			setIsLoading(false);
		});
	}, [currentPage, activeLanguage]);

	return (
		<section className="my-posted-jobs py-50">
			<Container fluid>
				<div className="white-box bg-white">
					<div className="list-heading">
						<h4 className="fw-bold mb-3 mb-lg-4">
							{companyId ? translate('Job.postedJobs') : translate('Job.myJobs')}
						</h4>
					</div>

					<div className="my-posted-jobs-list">
						<Row className="my-posted-jobs-list-row">
							{delayedLoading ? (
								<PostedJobSkeleton />
							) : (
								<>
									{jobs?.length > 0 ? (
										jobs.map((job: any) => (
											<Col lg={6} key={`${job?.title}-${job?.companyId}-${job?.job_id}`}>
												<JobListingBox
													job={job}
													key={`${job?.title}-${job?.job_id}-${job?.companyId}`}
													enableFavBtn={
														authUser?.userType === USER_TYPES?.SEEKER &&
														authUser?.userId !== job?.companyId
													}
													enableApplyBtn={false}
													enableAddress={false}
													enableKebabIcon={
														authUser?.userId === job?.companyId ||
														authUser?.userType === USER_TYPES?.SEEKER
													}
													refetch={refetch}
												/>
											</Col>
										))
									) : (
										<Stack className="posted-job-box">
											<p className="mb-0">{translate('Common.noJobsFound')}</p>{' '}
										</Stack>
									)}
								</>
							)}
						</Row>
					</div>

					{totalDocs > limit && (
						<PaginationBox
							totalData={totalDocs}
							limit={limit}
							page={currentPage}
							setCurrentPage={setCurrentPage}
						/>
					)}
				</div>
			</Container>
		</section>
	);
};

export default MyPostedJobs;
